import { render, staticRenderFns } from "./IconLamp.vue?vue&type=template&id=3db82f9a&"
import script from "./IconLamp.vue?vue&type=script&lang=js&"
export * from "./IconLamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports